function getGraphqlSchema (filename) {
  try {
    return require(`./${filename}.graphql`);
  } catch (error) {
    console.log('ERROR READING GRAPHQL SCHEMAS -> ', error);
    return error;
  }
}

module.exports = { getGraphqlSchema: getGraphqlSchema };
